<link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css" rel="stylesheet" />
<link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;700&display=swap" rel="stylesheet" />
<div class="landing-page">
  <div class="background-globes">
    <!-- <div class="globe globe-1"></div> -->
    <div class="globe globe-2"></div>
    <div class="globe globe-3"></div>
  </div>

  <div class="glass-overlay"></div>

  <div class="content-container">
    <div class="hero-section">
      <div class="logo-wrapper">
        <ddc-logo class="daydic-logo" [hasText]="true"></ddc-logo>
      </div>

      <h1 class="headline"><span class="highlight">AI-Native</span> Learning Platform</h1>
      <div class="cta-container">
        <a class="app-store-btn" href="https://apps.apple.com/de/app/daydic/id1531175789?l=en-GB" target="_blank">
          <i class="fab fa-apple apple-icon"></i>
          <div class="btn-text">
            <span>Download on the</span>
            <strong>App Store</strong>
          </div>
        </a>
      </div>
      <!-- QR code  -->
      <div class="qr-code-section">
        <img class="qr-code-img" alt="Daydic App Store QR Code" src="https://daydic.com/media/qr_codes/app.png" />
        <p class="qr-instruction">Scan to Download</p>
      </div>
      <p class="sub-headline" style="margin-top: 20px">
        The power of personalized learning is here ! Whether you're cramming for exams or mastering a new skill, Daydic
        makes learning addictive. Build your own quizzes, notes and dictionaries, share them with the world, and let
        Lingo (our AI Agent) guide your way by creating all of your learning materials.
      </p>
      <h2 class="headline-h2">Don't Create <span class="highlight-h2">Quizzes</span> Manually !</h2>
      <h2 class="headline-h2"><span class="highlight-h2">Lingo AI</span> Got You Covered.</h2>
    </div>

    <ddc-ad-carousel></ddc-ad-carousel>

    <footer class="footer" (click)="goToLogin()">
      <p>&copy; 2026 Daydic. All rights reserved.</p>
    </footer>
  </div>
</div>
